import { render, staticRenderFns } from "./ViewFeedback.vue?vue&type=template&id=3a4b2eeb&"
import script from "./ViewFeedback.vue?vue&type=script&lang=js&"
export * from "./ViewFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ViewFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports